import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
import n from "../../_virtual/_plugin-vue_export-helper.js";
const c = {}, s = {
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "#fff"
}, r = /* @__PURE__ */ o("path", {
  d: "M579.888 512l190.064-190.064a48 48 0 0 0-67.888-67.872L512 444.112 321.936 254.064a48 48 0 1 0-67.872 67.872L444.112 512 254.064 702.064a48 48 0 1 0 67.872 67.872L512 579.888l190.064 190.064a48 48 0 0 0 67.872-67.888L579.888 512z",
  fill: "",
  "p-id": "2532"
}, null, -1), l = [
  r
];
function i(_, f) {
  return e(), t("svg", s, l);
}
const h = /* @__PURE__ */ n(c, [["render", i]]);
export {
  h as default
};
